import { render } from "./AfsaReadView.vue?vue&type=template&id=07ad1608"
import script from "./AfsaReadView.vue?vue&type=script&lang=js"
export * from "./AfsaReadView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__